import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Memories",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
  {
    _id: 1005,
    title: "Journal",
    link: "/journal",
  },
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: spfOne,
    productName: "Cap for Boys",
    price: "Inquiry",
    color: "Blank and White",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: "202",
    img: newArrFour,
    productName: "Tea Table",
    price: "Inquiry",
    color: "Gray",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: "203",
    img: spfThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: "204",
    img: spfFour,
    productName: "Sun glasses",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    _id: 1001,
    img: spfOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Blank and White",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1002,
    img: spfTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Gray",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1003,
    img: spfThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1004,
    img: spfFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1005,
    img: bestSellerOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Blank and White",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1006,
    img: bestSellerTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Gray",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1007,
    img: bestSellerThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1008,
    img: bestSellerFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1009,
    img: newArrOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1010,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1011,
    img: newArrThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1012,
    img: newArrFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1013,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },

  {
    _id: 1014,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1015,
    img: newArrFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1016,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1017,
    img: bestSellerFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1018,
    img: newArrOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1019,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1020,
    img: newArrThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1021,
    img: spfThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1022,
    img: spfFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1023,
    img: bestSellerOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Blank and White",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1024,
    img: spfOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Blank and White",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1025,
    img: spfTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Gray",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1026,
    img: spfThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1027,
    img: spfFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1028,
    img: bestSellerOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Blank and White",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1029,
    img: bestSellerTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Gray",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1030,
    img: bestSellerThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1031,
    img: bestSellerFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1032,
    img: newArrOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1033,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1034,
    img: newArrThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1035,
    img: newArrFour,
    productName: "  Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1036,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1037,
    img: newArrFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1038,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1039,
    img: bestSellerFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: false,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1040,
    img: newArrOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1041,
    img: newArrTwo,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1042,
    img: newArrThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1043,
    img: spfThree,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Mixed",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1044,
    img: spfFour,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Black",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1045,
    img: bestSellerOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Blank and White",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
  {
    _id: 1046,
    img: spfOne,
    productName: "Old Delhi Tour",
    price: "Inquiry",
    color: "Blank and White",
    badge: true,
    des: "Old Delhi is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels. It is home to several iconic landmarks, including the Red Fort and India Gate.",
  },
];
// =================== PaginationItems End here =================
